export default __webpack_public_path__ + "static/earth_normal_map-1f8b1fb4a25a29db89113086e465338b.jpg";